// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1GsQ0","title":"InfoRow_title__1D4VH"};